// Reemplazo de 'vue-typeahead' (abandonado, apuntado a Vue 1.x/2.x, sin
// release para Vue 3). Es el mismo objeto de opciones que exportaba el
// paquete (src/main.js), sin cambios: no usa nada deprecado en Vue 3
// (ni filters, ni Vue.extend, ni functional), así que portarlo acá no
// agrega deuda nueva para la Fase 2.
// Los componentes que lo usaban con `extends: VueTypeahead` pasan a usar
// `mixins: [typeaheadMixin]` — en Vue 2 el merge de data/computed/methods
// es el mismo para ambos, y ninguno de los tres pisa una clave del padre
// con lógica distinta, así que el comportamiento es idéntico.
import { util } from 'vue';

export default {
  data() {
    return {
      items: [],
      query: '',
      current: -1,
      loading: false,
      selectFirst: false,
      queryParamName: 'q',
    };
  },

  computed: {
    hasItems() {
      return this.items.length > 0;
    },

    isEmpty() {
      return !this.query;
    },

    isDirty() {
      return !!this.query;
    },
  },

  methods: {
    update() {
      this.cancel();

      if (!this.query) {
        return this.reset();
      }

      if (this.minChars && this.query.length < this.minChars) {
        return;
      }

      this.loading = true;

      this.fetch().then((response) => {
        if (response && this.query) {
          let data = response.data;
          data = this.prepareResponseData ? this.prepareResponseData(data) : data;
          this.items = this.limit ? data.slice(0, this.limit) : data;
          this.current = -1;
          this.loading = false;

          if (this.selectFirst) {
            this.down();
          }
        }
      });
    },

    fetch() {
      if (!this.$http) {
        return util.warn('You need to provide a HTTP client', this);
      }

      if (!this.src) {
        return util.warn('You need to set the `src` property', this);
      }

      const src = this.queryParamName ? this.src : this.src + this.query;

      const params = this.queryParamName
        ? Object.assign({ [this.queryParamName]: this.query }, this.data)
        : this.data;

      const cancel = new Promise((resolve) => (this.cancel = resolve));
      const request = this.$http.get(src, { params });

      return Promise.race([cancel, request]);
    },

    cancel() {
      // used to 'cancel' previous searches
    },

    reset() {
      this.items = [];
      this.query = '';
      this.loading = false;
    },

    setActive(index) {
      this.current = index;
    },

    activeClass(index) {
      return {
        active: this.current === index,
      };
    },

    hit() {
      if (this.current !== -1) {
        this.onHit(this.items[this.current]);
      }
    },

    up() {
      if (this.current > 0) {
        this.current--;
      } else if (this.current === -1) {
        this.current = this.items.length - 1;
      } else {
        this.current = -1;
      }
    },

    down() {
      if (this.current < this.items.length - 1) {
        this.current++;
      } else {
        this.current = -1;
      }
    },

    onHit() {
      util.warn('You need to implement the `onHit` method', this);
    },
  },
};
